const REDUCE_RANGE_FACTOR = 0.05;
const PADDING_FACTOR = 0.6;
const MAX_PADDING = 0.3;
const MAX_PADDING_ONE_OPTION = 0.5;

interface RangeBandOptions {
  r: number[];
  p: number;
}

export const rangeBandOptions = (
  height: number,
  numChoices: number,
): RangeBandOptions => {
  const padding =
    numChoices <= 1
      ? MAX_PADDING_ONE_OPTION
      : Math.min(MAX_PADDING, (Math.LN10 * PADDING_FACTOR) / numChoices);
  const rangeInterval = [
    height * REDUCE_RANGE_FACTOR,
    height - height * REDUCE_RANGE_FACTOR,
  ];
  return { r: rangeInterval, p: padding };
};
